import { ButtonProps } from "./types";

export const Button = ({ children, customClass, ...props }: ButtonProps) => {
  return (
    <button
      className={`w-48 h-10 bg-white border-0 font-montserrat font-medium text-sm leading-5 text-gray-800 tracking-wider transition-colors duration-200 cursor-pointer ${customClass}`}
      {...props}
    >
      {children}
    </button>
  );
};
